export const cookie = {
  title: 'Politique en matière de cookies',
  lastUpdated: 'Dernière mise à jour : janvier 2025',
  
  intro: {
    title: 'Introduction',
    text: 'Cette Politique en matière de cookies explique comment NovaVenture Group BV (« nous », « notre ») utilise les cookies et technologies similaires sur notre site web. En utilisant notre site web, vous acceptez l\'utilisation des cookies comme décrit dans cette politique.'
  },

  whatAreCookies: {
    title: 'Que sont les cookies ?',
    text: 'Les cookies sont de petits fichiers texte qui sont placés sur votre appareil (ordinateur, tablette ou smartphone) lorsque vous visitez un site web. Les cookies aident les sites web à mémoriser vos préférences et à améliorer la fonctionnalité du site.'
  },

  cookiesWeUse: {
    title: 'Quels cookies utilisons-nous ?',
    intro: 'Actuellement, NovaVenture Group BV utilise uniquement des cookies fonctionnels strictement nécessaires. Nous n\'utilisons pas de cookies de suivi, d\'analyse ou de marketing.',
    
    necessary: {
      title: 'Cookies strictement nécessaires',
      description: 'Ces cookies sont essentiels au bon fonctionnement de notre site web. Sans ces cookies, le site web ne peut pas fonctionner correctement. Ces cookies ne collectent pas d\'informations personnelles et ne peuvent pas être désactivés.',
      examplesLabel: 'Exemples :',
      examples: 'Cookies de session, préférence de langue, cookies de sécurité'
    },

    noTracking: {
      title: 'Pas de cookies de suivi ou de marketing',
      description: 'Nous n\'utilisons actuellement pas de cookies à des fins de suivi, d\'analyse ou de marketing. Votre comportement de navigation n\'est pas suivi et aucun profil n\'est créé à votre sujet.'
    }
  },

  futureTracking: {
    title: 'Utilisation future de cookies de suivi',
    text: 'Si nous décidons d\'utiliser des cookies de suivi, d\'analyse ou de marketing à l\'avenir, nous vous demanderons votre consentement explicite au préalable via une bannière de cookies. Vous aurez alors la possibilité d\'accepter ou de refuser ces cookies.'
  },

  manageCookies: {
    title: 'Gérer les cookies',
    intro: 'Vous pouvez gérer les cookies via les paramètres de votre navigateur web. La plupart des navigateurs offrent la possibilité de :',
    browsers: {
      chrome: 'Google Chrome : Paramètres > Confidentialité et sécurité > Cookies et autres données de site',
      firefox: 'Mozilla Firefox : Paramètres > Vie privée et sécurité > Cookies et données de site',
      safari: 'Safari : Préférences > Confidentialité > Cookies et données de site web',
      edge: 'Microsoft Edge : Paramètres > Cookies et autorisations de site'
    },
    warning: 'Attention : La désactivation des cookies strictement nécessaires peut limiter la fonctionnalité de notre site web.'
  },

  updates: {
    title: 'Modifications de cette politique en matière de cookies',
    text: 'Nous nous réservons le droit de modifier cette Politique en matière de cookies. Toute modification sera publiée sur cette page. Nous vous recommandons de consulter régulièrement cette politique pour rester informé de tout changement.'
  },

  contact: {
    title: 'Contact',
    intro: 'Vous avez des questions sur notre Politique en matière de cookies ? Contactez-nous :'
  },

  moreInfo: {
    title: 'Plus d\'informations',
    intro: 'Pour plus d\'informations sur la manière dont nous traitons vos données, veuillez consulter :',
    privacyLink: 'Politique de confidentialité',
    termsLink: 'Conditions générales'
  }
};